import { Box, Container } from '@mui/material'
import useModalState from '../../../../../shared/hooks/useModalState'
import { useUserBrandsState } from '../../hooks/detail/useUserBrandsState'
import { UserBrandsList } from './brands/UserBrandsList'
import { VipModal } from './brands/VipModal'

function UserBrands() {
  const { open, openModal, closeModal } = useModalState()
  const { vipContentState, tmpBrands, tmpBrandLines, setTmpBrandLines, handleClose, handleInputChange, handleSubmit } =
    useUserBrandsState(closeModal)

  return (
    <>
      <Container className="noPadding">
        <Box mt={2} mb={5}>
          <UserBrandsList
            brands={tmpBrands}
            setTmpBrandLines={setTmpBrandLines}
            handleInputChange={handleInputChange}
            openModal={openModal}
          />
        </Box>

        <VipModal
          open={open}
          vipContentState={vipContentState}
          handleClose={handleClose}
          tmpBrandLines={tmpBrandLines}
          handleInputChange={handleInputChange}
          handleSubmit={handleSubmit}
        />
      </Container>
    </>
  )
}

export default UserBrands
